// Static copy/data driving the marketing landing page. Pulled out of
// Landing.js so the section components can render with no JS logic of their own.

import {
  ShieldCheck, AlertTriangle, Search, FileWarning, FilePlus2, Eye, Repeat,
  Users, Building2, Sparkles, BookOpenCheck, ScrollText, BadgeCheck,
} from "lucide-react";

export const HERO_IMG = "https://images.pexels.com/photos/271639/pexels-photo-271639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export const NAV_ITEMS = [
  { label: "Home", to: "#top" },
  { label: "How it works", to: "#how" },
  { label: "Intel Categories", to: "#categories" },
  { label: "Compliance", to: "#compliance" },
  { label: "Integrations", to: "#integrations" },
  { label: "Resources", to: "#resources" },
  { label: "Contact", to: "#contact" },
];

export const PROBLEM_LIST = [
  { label: "Property Damage", icon: FileWarning },
  { label: "Chargebacks", icon: ScrollText },
  { label: "Unauthorized Occupancy", icon: Building2 },
  { label: "Staff Safety Incidents", icon: AlertTriangle },
  { label: "Fraudulent Reservations", icon: ShieldCheck },
  { label: "Repeat Problem Guests", icon: Repeat },
];

export const SOLUTION_LIST = [
  "Document incidents",
  "Store evidence securely",
  "Search verified intelligence",
  "Identify recurring patterns",
  "Improve operational awareness",
  "Protect staff and property",
];

export const STEPS = [
  { n: "01", title: "Report",  body: "Property submits an incident report with photos, damage estimates and supporting documentation.", icon: FilePlus2 },
  { n: "02", title: "Verify",  body: "GuestIntel reviews every submission and validates the supporting evidence before it enters the network.", icon: BookOpenCheck },
  { n: "03", title: "Search",  body: "Participating properties search incoming reservations against the verified intelligence library.", icon: Search },
  { n: "04", title: "Review",  body: "Properties review what's on file and make better-informed operational decisions — before check-in.", icon: Eye },
];

export const CATEGORIES = [
  { title: "Property Damage Intel", color: "#0F766E", items: ["Furniture Damage", "Smoke Damage", "Room Vandalism"] },
  { title: "Payment Intel",          color: "#0E7490", items: ["Chargebacks", "Unpaid Balances", "Fraudulent Transactions"] },
  { title: "Conduct Intel",          color: "#9D174D", items: ["Staff Harassment", "Threatening Behavior", "Policy Violations"] },
  { title: "Safety Intel",           color: "#7C2D12", items: ["Illegal Activities", "Security Incidents", "Law Enforcement Reports"] },
];

export const BENEFITS = [
  { title: "Reduce Property Losses", body: "Identify repeat incidents before they become costly.",            icon: ShieldCheck },
  { title: "Protect Staff",          body: "Help employees stay informed about prior documented incidents.",  icon: Users },
  { title: "Strengthen Operations",  body: "Make better-informed decisions with verified intelligence.",      icon: Sparkles },
  { title: "Trusted Community",      body: "Participate in a growing network of hospitality professionals.",  icon: BadgeCheck },
];

export const GOVERNANCE = [
  "Intel Shield™ — Privacy-First Matching",
  "Verified Business Membership",
  "Evidence-Based Reporting",
  "Audit Trails",
  "Data Security Controls",
  "Record Review Processes",
  "Dispute Resolution Procedures",
  "Privacy Protection Framework",
];

export const PLANS = [
  { tier: "Starter",      forWhom: "For Independent Hotels",       bullets: ["Incident Reporting", "Intel Search", "Basic Dashboard"], cta: "Start free trial" },
  { tier: "Professional", forWhom: "For Multi-Property Operators", bullets: ["Advanced Search", "Analytics", "Team Access"],            cta: "Start free trial", highlighted: true },
  { tier: "Enterprise",   forWhom: "For Hotel Groups",             bullets: ["API Access", "PMS Integration", "Dedicated Support"],     cta: "Talk to sales" },
];

export const INTEGRATIONS = [
  "eHOTL PMS", "StayTransit", "Major PMS Platforms", "Channel Managers", "Reservation Systems",
];

export const slugify = (s) => s.toLowerCase().replace(/\s+/g, "-");
